/** Consultas comerciais usadas pelas telas de venda (ERP Web e CaféGestor Vendedor). */
import type { PriceLookup } from "@cafegestor/shared";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./api";

/** Preço de tabela do cliente (válida hoje) e disponibilidade do produto no depósito. */
export function usePriceLookup(args: {
  customerId: string;
  productId: string;
  unitId: string;
  warehouseId: string;
}) {
  const params = new URLSearchParams({
    customerId: args.customerId,
    productId: args.productId,
    unitId: args.unitId,
  });
  if (args.warehouseId) params.set("warehouseId", args.warehouseId);
  return useQuery({
    queryKey: ["vendas", "precos", params.toString()],
    queryFn: () => apiFetch<PriceLookup>(`/vendas/precos?${params.toString()}`),
    enabled: args.customerId !== "" && args.productId !== "" && args.unitId !== "",
    staleTime: 15_000,
  });
}
